import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Modal } from 'bootstrap';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { DriverSalaryItem, RateItem, RateKind } from '../driver.model';

@Component({
	selector: 'app-drivers-salary-days',
	templateUrl: './drivers-salary-days.component.html',
	styleUrls: ['./drivers-salary-days.component.css'],
})
export class DriversSalaryDaysComponent implements OnChanges {
	editable = false;
	@Input() driver: any;
	@Output() closed = new EventEmitter();
	salaryType: Array<any> = [
		{ id: 0, name: '' },
		{ id: 1, name: 'Jezdna' },
		{ id: 2, name: 'Leżona' },
		{ id: 3, name: 'Inna' },
	];
	diets: Array<any> = [
		{ value: 0, name: '(brak)' },
		{ value: 38, name: 'Polska(stara)', disabled: true },
		{ value: 45, name: 'Polska', disabled: false },
		{ value: 50, name: 'Zagraniczna', disabled: false },
	];
	driversSalaryDays: Array<any> = [];
	taxSalary: Array<any> = [];
	historyOperationLast = {
		date: null,
		user: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.driver && this.driver) {
			const parms = `tourismEventDriver=${this.driver.tourismEventDriver}&driver=${this.driver.driver}`;
			this.api.get(`/driversSalaryDays?${parms}`, (result, error) => {
				this.driversSalaryDays = result.data.data.map((obj) => {
					obj.confirmed = obj.confirmed == '1' ? true : false;
					return obj;
				});

				this.historyOperationLast = result.data.history[0];
				this.taxSalary = result.data.taxSalary;
			});
			this.dialogOpen();
		}
	}

	dialogOpen() {
		new Modal(document.getElementById('driversSalaryDaysModal')).show();
	}

	save() {
		const days = [];
		this.editable = false;
		this.driversSalaryDays.forEach((obj) => {
			this.objectEdit(obj);
			days.push(obj.day.slice(0, -3));
		});
	}

	private objectEdit(obj) {
		this.api.put(`/driversSalaryDays/${obj.id}/`, obj, (result, error) => {
			if (error) {
				return;
			}
		});
	}

	confirmed(driver) {
		if (!driver.confirmed) {
			this.dialogClose();
		}
		driver.confirmed = !driver.confirmed;
		this.api.command(
			`/driversSalaryDays/${driver.tourismEventDriver}/`,
			{ cmd: 'confirmed', set: driver.confirmed },
			(result, error) => {
				if (error) {
					driver.confirmed = !driver.confirmed;
					this.infobox.error(error.error.error);
					return;
				}
			},
		);
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('driversSalaryDaysModal'));
		if (!modal) {
			return;
		}
		modal.hide();
		this.closed.emit();
	}

	changeSalaryType(event: RateKind, item: DriverSalaryItem): void {
		this.api.get(`/driver/driverTax/?driver=${item.driver}&day=${item.day}/`, (result, error) => {
			this.selectTax(event, item, result.data);
		});
	}

	selectTax(event: RateKind, item: DriverSalaryItem, data: RateItem): void {
		switch (event) {
			case RateKind.WORK_RATE:
				item.salary = data.workRate;
				break;
			case RateKind.BREAK_RATE:
				item.salary = data.breakRate;
				break;
			case RateKind.OTHER_RATE:
				item.salary = data.otherRate;
				break;
		}
		item.type = event;
	}
}
